<template>
    <div class="page-class"
        :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}">
        <div class="page-wrapper">
            <div class="page-content"
                v-if="isAccountLoaded">
                <nav-bar
                    :pageName="navbarName"
                    :userType="userType"
                    :longText="longText"
                    @clickBack="clickBack"></nav-bar>
                <div class="copy-personal-content">
                    <div>
                        <div class="text-copy-personal">
                            <div class="text-title">{{lbl.copy.name}}</div>
                            <div class="text-detail">{{`${profile.strFirstName}`}}</div>
                        </div>
                        <div class="text-copy-personal">
                            <div class="text-title">{{lbl.copy.lastname}}</div>
                            <div class="text-detail">{{`${profile.strLastName}`}}</div>
                        </div>
                        <div class="text-copy-personal">
                            <div class="text-title">{{lbl.copy.birthday}}</div>
                            <div class="text-detail">{{birthday}}</div>
                        </div>
                        <div class="text-copy-personal">
                            <div class="text-title">{{lbl.copy.tel}}</div>
                            <div class="text-detail">{{`${profile.strContactNumber}`}}</div>
                        </div>
                        <div class="text-copy-personal">
                            <div class="text-title">{{lbl.copy.age}}</div>
                            <div class="text-detail">{{lbl.copy.age_detail}}</div>
                        </div>
                    </div>
                    <div id="input_email" class="input-area">
                        <div class="title-email">{{lbl.copy.email_headline}}</div>
                        <Email  addClass="ep-input"
                                :errorInfo="errorInfo[0]"
                                inputId="personal_email"
                                :inputLbl="lbl.copy.email"
                                :isShowError="true"
                                :isSubmitted="isSubmitted"
                                :inputMaxLength="60"
                                :copyPersonal="true"
                                v-model="formData.email"
                                @input="onEmailChange($event)"
                            />
                    </div>
                    <div class="text-copy-personal">
                        <div class="text-detail">
                            <div class="text-title">{{lbl.copy.pin}}</div>
                            <div>
                            <div class="box-pin">
                                <label for="input-pin">
                                    <div class="d-flex justify-content-center">
                                        <div class="box-input-pin">{{formData.pin[0]}}</div>
                                        <div class="box-input-pin">{{formData.pin[1]}}</div>
                                        <div class="box-input-pin">{{formData.pin[2]}}</div>
                                        <div class="box-input-pin">{{formData.pin[3]}}</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <input  type="tel"
                                id="input-pin"
                                class="input-pin-dummy"
                                maxlength="4"
                                v-model="formData.pin"
                                @input="onPinChange()">
                        </div>
                    </div>
                </div>
                <div class="copy-personal-content">
                    <div class="text-copy-personal">
                        <div class="btn-footer">
                            <div class="btn-wrapper" v-if="isValid" @click="onClickSubmit()">
                                <div class="btn-txt">
                                    {{ lbl.edit_profile.edit_profile_btn }}
                                </div>
                            </div>
                            <div class="btn-wrapper btn-disable" v-else>
                                <div class="btn-txt">
                                    {{ lbl.edit_profile.edit_profile_btn }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-bg"></div>
        </div>
        <modal-master
            :controller="modalController"
            :theme="userType"
        ></modal-master>
    </div>
</template>
<script>
import Vue from 'vue';
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//helper
import Locale from '@/helper/locale/locale.js';
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import FormHelper from "@/helper/FormHelper.js";
//component
import NavBar from "@/components/Layout/NavBar/NavBar.vue";
import Email from "@/components/Input/Email.vue";
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
// error
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
export default {
    name: 'CopyPersonal',
    mixins: [AccountMixin, ErrorApiMixin],
    components: {
        NavBar,
        Email,
        ModalMaster
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),
            navbarName: "",
            longText: false,
            tel: null,
            birthday: null,
            formData: {
                email: '',
                pin: '',
            },
            errorInfo: [],
            isValid: false,
            isSubmitted: false,
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),
            isLoading: false,
            errorHandler: null,
        };
    },
    created: function () {
        var page = this.$route.params.page;
        if (page == 'copy') {
            this.navbarName = this.lbl.copy.req_headline;
        } else {
            this.navbarName = this.lbl.copy.send_headline;
            this.longText = true;
        }
        this.errorInfo = FormHelper.genErrorInfo(1);
        // modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);
        // error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);

        this.getDataProfile();
    },
    methods: {
        // initial
        accountInitiated: function() {
            this.tel = this.profile.strContactNumber;

            if (this.profile.strBirthDate) {
                this.birthday = DatetimeHelper.dateFullFormat(this.profile.strBirthDate);
            }
        },
        clickBack: function () {
            this.$router.push('/profile');
        },
        getDataProfile: function() {
            this.tel = this.profile.strContactNumber;
            this.birthday = this.profile.strBirthDate;
        },
        onEmailChange : function(email) {
            this.formData.email = email;
            this.validateData();
        },
        onPinChange: function() {
            this.formData.pin = this.formData.pin.replace(/\D/g, '');
            this.errorText = '';
            this.validateData();
        },
        validateData: function() {
            if (this.formData.email && this.formData.pin.length == 4) {
                this.isValid = true;
            } else {
                this.isValid = false;
            }
        },
        submitCopyPersonal: function () {
            var token = this.getToken();
            var params = {
                email: this.formData.email,
                pin: this.formData.pin
            }
            this.showLoading();
            BzbsProfile.apiPostCopyPersonal(token,params)
                .then(() => {
                    this.hideLoading();
                    this.modalController.alertModal
                                        .clearText()
                                        .setMsg(this.lbl.profile.copy_personal.alert_copy)
                                        .setBtnOk(this.lbl.profile.copy_personal.btn)
                                        .show();
                })
                .catch(err => {
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        onClickSubmit: function() {
            var isEmailValid = Vue.validator.validateEmail(this.formData.email)
            if (isEmailValid) {
                this.submitCopyPersonal();
            }
        },
        showLoading: function() {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function() {
            this.isLoading = false;
            this.loadingModal.hide();
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
.copy-personal-content {
    max-width: $page-max-width;
    // width: 100%;
    .text-copy-personal {
        line-height: 1.56;
        text-align: left;
        margin: 15px 37px 20px 32px;
        position: relative;

        .text-title {
            color: $text-gray;
            font-size: 1.375rem;
        }
        .text-detail {
            font-size: 1.6rem;
            .text-title {
                color: $text-gray;
                font-size: 1.6rem;
            }
            .box-pin {
                text-align: left;
            }
            .box-input-pin {
                width: 40px;
                height: 53px;
                border: solid 1px $line-gray;
                border-radius: 5px;
                margin: 3px 3px 10px;
                padding-top: 8px;
                text-align: center;

            }
            .input-pin-dummy {
                position: absolute;
                // top: -20000px;
                left: -20000px;
                opacity: 0;
            }
        }

        .btn-footer {
            padding: 30px 0;
            position: absolute;
            top: 20px;
            width: 100%;
            .btn-wrapper {
                height: 50px;
            }
        }
    }
    .input-area {
        margin: 50px 30px 25px 30px;
        font-size: 1.6rem;
        color: $text-gray;

        .title-email {
            margin-bottom: -0.875rem;
        }
    }
}

</style>
<style lang="scss">
@import "@/style/base/common.scss";
#input_email {
    width: 85%;
    .ep-input {
        .input-wrapper {
            #personal_email {
                border: 1px solid $line-gray;
                border-radius: 5px;
                padding-left: 15px;
                width: 100%;
                height: 45px;
                input {
                    padding-left: 0;
                    font-size: 1.6rem;
                    width: 100%;
                }
            }
            .input-lbl {
                color: $text-gray;
                font-size: 1.45rem;
            }
        }
    }
}
</style>
